import type {ReactElement} from 'react';
import type {BrandColor, BrandContent} from '@Components/editor-brands/editor-brands.types';
import {Swatches} from '@Components/color-picker-v2/components/swatches';
import {SwatchesLayout} from '@Components/color-picker-v2/components/swatches/swatches.types';
import {useAppSelector} from '@/hooks';

export interface BrandColorsProps {
  /** ROUND_GRID shows the kit as the colour popup's circle grid. */
  layout?: SwatchesLayout;

  onAddColor(color: string): void;
}

function BrandColors({layout = SwatchesLayout.WRAP, ...props}: BrandColorsProps): ReactElement<any> {
  const activeBrandId: string = useAppSelector((state) => {
    return state.brands.activeBrandId ?? '';
  });
  const brandContent: Record<string, BrandContent> = useAppSelector((state) => {
    return state.brands.brandContent;
  });
  const brandColors: Record<string, BrandColor> = useAppSelector((state) => {
    return state.brands.colors;
  });

  const onAddColor = (color: string): void => {
    props.onAddColor(color);
  };

  const getBrandColorHexCodes = (): string[] => {
    return brandContent[activeBrandId].colors.ids.map((id) => {
      return brandColors[id].hexCode;
    });
  };

  return <Swatches className="spacing-p-t-3" colors={getBrandColorHexCodes()} onClick={onAddColor} layout={layout} hasCustomMargins />;
}

export default BrandColors;
